var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoiceAccounting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(2.989917 2.978673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.010083 8.021327h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.010083 5.021327h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.51008254 14.0213269-.01-.001c-.83-.01-1.5-.68-1.5-1.5h-.01c0-.83.67-1.5 1.49-1.51l-.01-.001c.82 0 1.49.67 1.5 1.49v-.01c-.01.82-.68 1.49-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.51008254 14.2713269h2.49999996v3.75h-2.49999996-.01c-.28-.01-.5-.23-.5-.51v-2.75c-.01-.28.22-.51.49-.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5100825 10.0213269h2-.01c.27-.01.5.22.5.49v7.5h-3v-7.5c-.01-.28.22-.51.49-.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.5100825 12.2713269h2-.01c.27-.01.5.22.5.49v4.75c0 .27-.23.5-.5.5h-2.5v-5.25c-.01-.28.22-.51.49-.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.01008254 18.0213269h-4l-.01-.001c-1.11-.01-2.00008254-.9-2.00008254-2.01v-13.99999999c-.00991746-1.11.89008254-2.01 1.99008254-2.01h8.16999996-.01c.53-.01 1.03.21 1.41.58l2.82 2.82c.37.37.58.88.58 1.41v2.17"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceAccounting);
export default __webpack_public_path__ + "static/media/invoice-accounting.963e9e522ef57e281f6838caf076ebfa.svg";
export { ForwardRef as ReactComponent };